import { useState } from "react";

export const useSearchParameters = () => {
  const [searchParameters] = useState(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return Object.fromEntries(urlSearchParams.entries());
  });

  return searchParameters;
};
